// store/auth.ts
import { create } from 'zustand';
import { UserInfo } from "@/hooks/use-auth";

interface AuthState {
  user: UserInfo | null;
  setUser: (user: AuthState['user'] | null) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null, // Initial state: no user is authenticated
  setUser: (user) => set({ user }) // Function to update the user state
}));
